export default {
	common: {
		viewMore: '查看更多'
	},
	banner: {
		title: '投資者關係',
		aboutOSL: '關於 OSL',
		subtitle: '亞洲領先的穩定幣交易及支付基礎設施',
		description: `OSL致力於在全球範圍內提供合規高效的數字金融基礎設施服務，讓任何企業、金融機構和個人都能實現法幣貨幣與數字資產間的
			無縫兌換、支付、交易與結算`
	},
	nav: {
		home: '首頁',
		financials: '業績和財務報告',
		filings: '證券公告',
		newsEvents: '新聞和活動',
		corporateGovernance: '公司治理',
		investorTools: '投資者工具'
	},
	pages: {
		home: {
			title: '首頁',
			welcome: '歡迎來到投資者關係平台',
			description: '探索我們的財務資訊、文件檔案、新聞活動、公司治理和投資者工具。',
			stockInformation: '股票行情',
			financials: '業績',
			news: '新聞',
			events: '活動',
			irContact: '聯繫我們',
			irContactSection: {
				investorContact: '投資者聯繫',
				investorContactDesc: '投資者關係相關問題請發送郵件至 {link}，或點擊下面的按鈕。',
				investorContactLink: 'ir@osl.com',
				contactUs: '聯繫我們',
				email: '郵箱'
			}
		},
		financials: {
			title: '業績',
			interim: '半年度',
			annual: '年度',
			announcements: '公告',
			fullReport: '完整報告',
			presentation: '演示材料',
			webcast: '網絡回放',
			viewMore: '查看更多'
		},
		filings: {
			title: '香港聯交所公告',
			year: '年份',
			category: '事項分類(可多選)',
			pleaseSelect: '請選擇',
			keyword: '關鍵詞',
			search: '查詢',
			reset: '重置',
			tableCategory: '事項分類',
			description: '描述',
			date: '日期',
			view: '查看',
			totalResults: '結果數量',
			itemsPerPage: '每頁顯示',
			previous: '上一頁',
			next: '下一頁'
		},
		newsEvents: {
			title: '新聞和活動'
		},
		news: {
			title: '新聞'
		},
		events: {
			title: '活動'
		},
		corporateGovernance: {
			title: '公司治理',
			tabs: {
				seniorManagement: '高級管理層',
				boardMembers: '董事會成員',
				corporateGovernanceFiles: '公司治理文件',
				committeesAndBoardRoles: '委員會構成'
			},
			table: {
				date: '日期',
				document: '文件',
				download: '下載'
			},
			committeesTable: {
				name: '姓名',
				boardRoles: '董事角色',
				auditCommittee: '審核委員會',
				nominationCommittee: '提名委員會',
				remunerationCommittee: '薪酬委員會',
				riskManagementCommittee: '風險管理委員會',
				chairman: '主席',
				member: '成員'
			},
			updateLatestFile: '更新於：{date}'
		},
		investorTools: {
			title: '投資者工具',
			tabs: {
				analystCoverage: '分析師覆蓋',
				investorFAQs: '常見問題',
				investorEmailAlerts: '郵件訂閱',
				investorContacts: '聯繫 IR'
			}
		},
		investorEmailAlerts: {
			title: '郵件訂閱提示',
			instructionsRow01:
				'若您希望訂閱投資者郵件提醒，請在下方輸入您的電子郵箱地址，並至少選擇一項提醒類型。提交發送驗證碼請求後，您將在該電子郵箱中收到一封含有驗證碼的郵件。您必須在提交訂閱時，輸入郵件中收到的驗證碼，方可完成訂閱。',
			instructionsRow02: '在 OSL，我們承諾以負責任的方式處理和管理您的個人資料，嚴格遵守我們的{policy}。',
			instructionsRowPolicy: '《隱私政策》',
			instructionsRow03: '通過在下方提供您的電子郵箱地址，即表示您同意 OSL 向您發送所訂閱的投資者郵件提醒更新。',
			unsubscribe: '取消郵件訂閱提示',
			unsubscribeDescription:
				'若您希望取消訂閱投資者郵件提醒，請在下方輸入您的電子郵箱地址，系統將爲您移除所有已訂閱的投資者關係類郵件提醒。提交發送驗證碼請求後，您將在該電子郵箱中收到一封含有驗證碼的確認郵件。您必須點擊輸入並提交郵件中的驗證碼，方可完成取消訂閱的請求。',
			required: '必填',
			privacyHint: '進一步了解我們如何保護您的信息，請參閱我們的 {link}。',
			privacyPolicy: '隱私政策',
			form: {
				email: '郵箱',
				verification: '驗證碼',
				sendCode: '獲取驗證碼',
				sendCodeCountdown: '獲取驗證碼({seconds}s)',
				events: '投資者提醒選項',
				unsubscribe: '取消訂閱',
				submit: '提交'
			},
			placeholders: {
				email: '請輸入您的郵箱地址',
				verificationCode: '請輸入驗證碼',
				emailInHome: '輸入您的郵箱地址',
				verificationCodeInHome: '輸入驗證碼'
			},
			validation: {
				emailRequired: '請輸入郵箱地址',
				emailInvalid: '請輸入有效的郵箱地址',
				verificationCodeRequired: '請輸入驗證碼',
				subscribeRequired: '請至少選擇一項訂閱內容'
			},
			submitSuccess: '訂閱成功！',
			unsubscribeSuccess: '取消訂閱成功！',
			unsubscribeFailed: '您還未訂閱，無法取消訂閱',
			subscribeFailed: '郵箱已訂閱，請勿重複訂閱',
			sendCodeTooFrequent: '驗證碼發送過於頻繁，請稍候再試'
		},
		investorContacts: {
			form: {
				firstName: '名字',
				lastName: '姓氏',
				email: '郵箱',
				phone: '電話',
				company: '機構',
				title: '主題',
				question: '內容',
				submit: '提交',
				reset: '重置'
			},
			placeholders: {
				firstName: '請輸入您的名字',
				lastName: '請輸入您的姓氏',
				email: '請輸入您的郵箱',
				phone: '請輸入您的電話',
				company: '請輸入您的機構信息',
				title: '請輸入主題',
				question: '請輸入您的留言內容',
				customField: '請輸入{name}'
			},
			validation: {
				firstNameRequired: '請輸入您的名字',
				lastNameRequired: '請輸入您的姓氏',
				emailRequired: '請輸入您的郵箱',
				emailInvalid: '請輸入有效的郵箱地址',
				phoneRequired: '請輸入您的電話',
				companyRequired: '請輸入您的機構信息',
				titleRequired: '請輸入主題',
				questionRequired: '請輸入您的問題或留言',
				customFieldRequired: '請輸入{name}'
			},
			submitSuccess: '您的郵件已成功發送。',
			leaveWordTips:
				'在此欄下方，您可以留下寶貴建議。我們將認真聽取每一位投資者的反饋，並儘快予以回覆。您的參與將爲公司的發展注入新的活力。期待您的參與，共創美好未來。',
			privacyHint:
				'提交您的聯繫信息即表示您同意 OSL 使用您的個人資料以回應您的查詢及管理投資者溝通。OSL 將按照我們的 {link} 處理您的資料。',
			privacyPolicy: '隱私政策'
		},
		analystCoverage: {
			table: {
				company: '機構',
				analysts: '分析師',
				email: '電子郵箱'
			}
		},
		investorFAQs: {
			displayAll: '展開全部',
			hideAll: '收起全部'
		},
		notFound: {
			message: '頁面未找到',
			backBtn: '返回首頁'
		}
	},
	language: {
		select: '選擇語言',
		english: 'English',
		simplified: '中文(简体)',
		traditional: '中文(繁體)'
	},
	footer: {
		columns: {
			company: '公司',
			individual: '個人',
			enterprise: '企業',
			community: '社區',
			buyCrypto: '買數字資產',
			help: '幫助',
			legal: '法律'
		},
		company: {
			aboutUs: '關於我們',
			team: '團隊',
			investorOverview: '投資者關係',
			joinUs: '加入我們',
			marketFocus: '市場焦點',
			blog: 'OSL 網誌',
			mediaCoverage: '媒體報道',
			cryptoEncyclopedia: '幣懂百科',
			announcement: '公告中心'
		},
		individual: {
			flashTrade: '閃電交易',
			privateClients: '私人客戶',
			proTrade: '專業交易',
			recurringBuy: '定投'
		},
		enterprise: {
			proTrade: '專業交易',
			otc: '場外交易',
			custody: '託管',
			staking: '質押服務',
			wealthManagement: '財富管理',
			rwa: 'RWA',
			omnibus: 'Omnibus',
			stablex: 'StableX',
			api: 'API'
		},
		community: {
			emailPrompt: '輸入您的電郵地址以接收來自 OSL 及其母公司 (OSL集團) 的訊息和更新',
			emailPlaceholder: '輸入您的電子郵箱',
			emailConsent: '輸入您的電子郵件即表示您承認並同意 OSL 根據隱私政策收集和使用您的個人數據。',
			downloadApp: '下載 App'
		},
		buyCrypto: {
			buyBitcoin: '買 比特幣',
			buyEthereum: '買 以太坊',
			productDisclosure: '產品披露'
		},
		help: {
			supportCenter: '幫助中心',
			fees: '費用',
			contactUs: '聯繫我們'
		},
		legal: {
			terms: '條款及細則',
			riskDisclosure: '風險披露',
			tokenRules: '代幣上架和移除規則',
			tradingRules: '交易規則',
			privacyPolicy: '隱私政策'
		},
		copyright: {
			rights: '© OSL 版權所有。',
			disclaimer1: '本網站涉及數字資產交易，可能包括數字證券和其他複雜金融產品或工具，可能不適合所有投資者。',
			disclaimer2: '本網站不構成任何數字資產或金融工具交易的招攬、邀請或要約。'
		}
	},
	stock: {
		hkStockExchange: '香港聯交所',
		tips: '至少延遲 15 分鐘。來源：進門',
		hkt: 'HKT'
	},
	stockChart: {
		Price: '收盤價',
		Volume: '成交量'
	},
	links: {
		policyHref: 'https://www.osl.com/hk/support/privacy-policy'
	}
};
